import { Route, Routes, Navigate } from "react-router-dom";
import LoginView from "@/views/LoginView";
import DashboardView from "@/views/DashboardView";
import AdminDashboardView from "@/views/AdminDashboardView";
import ContentReviewView from "@/views/ContentReviewView";
import FavouritesView from "@/views/FavouritesView";
import PicassoParsnipView from "@/views/PicassoParsnipView";
// do this import ArchivesView from "@/views/ArchivesView";
import ProtectedRoute from "./protectedRoute";
import { LoadingProvider } from "@/components/loading/LoadingContext";
import PicassoLayout from "@/components/layout/PicassoLayout";
import { WebSocketProvider } from "@/utils/contexts/WebSocketContext";

const PicassoRoutes = () => {
  return (
    <LoadingProvider>
      <PicassoLayout>
        <WebSocketProvider>
          <Routes>
            <Route
              path="/"
              element={<Navigate to="login" replace />}
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute requiredRole={["user", "admin"]}>
                  <DashboardView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminDashboardView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/content-review"
              element={
                <ProtectedRoute requiredRole={["admin", "user"]}>
                  <ContentReviewView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/favourites"
              element={
                <ProtectedRoute requiredRole={["user", "admin"]}>
                  <FavouritesView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/parsnip"
              element={
                <ProtectedRoute requiredRole={["user", "admin"]}>
                  <PicassoParsnipView />
                </ProtectedRoute>
              }
            />
            {/* Commented out Archives route */}
            {/* <Route
              path="/archives"
              element={
                <ProtectedRoute requiredRole="admin">
                  <ArchivesView />
                </ProtectedRoute>
              }
            /> */}
            <Route 
              path="/login" 
              element={
                <ProtectedRoute publicRoute={true}>
                  <LoginView />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </WebSocketProvider>
      </PicassoLayout>
    </LoadingProvider>
  );
};

export default PicassoRoutes;
